var helloWorkJobs = false;
jQuery(document).ready(function(){
    if(typeof theme === "undefined" || !theme.hasOwnProperty('helloWorkJSONUrl') || !theme.hasOwnProperty('adminAjax') ) return;
    if(jQuery('.wp-block-vif-hellowork').length) initHelloWorkFlux(buildDomJobOffer, buildDomError);
})

function initHelloWorkFlux(callback, errorCallBack){
    jQuery.ajax({
        url: theme.helloWorkJSONUrl,
        type: "GET",
        dataType: "json",
    }).done((data)=>{
       if(data.hasOwnProperty('Results')){
        helloWorkJobs = data.Results;
        callback();
       }
    }).error((data)=>{
        errorCallBack();
    })
}
function buildDomError(){
    jQuery('.wp-block-vif-hellowork').each(function(){
        let currentJobsContainer = jQuery(this);
        currentJobsContainer.removeClass('load');
        currentJobsContainer.append(jQuery('<p/>').text('Jobs error'));
    });
}
function buildDomJobOffer(){
    jQuery('.wp-block-vif-hellowork').each(function(){
        let currentJobsContainer = jQuery(this);
        currentJobsContainer.removeClass('load');
        jQuery.ajax({
            url: theme.adminAjax,
            type: "POST",
            data: {
                "action": "get_offer_template",
                "model": currentJobsContainer.data('model'),
                "jobsPerPage": currentJobsContainer.data('jobs-per-page'),
                "offers": helloWorkJobs,
            }
        }).done((data)=>{
            currentJobsContainer.append(data);
        }).error(()=>currentJobsContainer.append(jQuery('<p/>').text('Jobs error')))
    })
}